/* LZ Ne pegla — kalkulator pegle, kartice koje se okreću (brojač + bonus), čipovi kategorija sa komadima.
   Učitava se iz dve sekcije; izvršava se jednom. Stanje otkrivenih kartica i izabranog čipa u sessionStorage. */
(() => {
  if (window.__lznp) { window.__lznp(); return; }
  const KEY = 'lznp:' + location.pathname;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let st = { open: [], tab: 0 };
  try { st = Object.assign(st, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const tpl = (str, map) => String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const track = (event, data) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event }, data || {})); } catch (e) {} };
  const hoursWord = (n) => { const m10 = n % 10, m100 = n % 100; return (m10 === 1 && m100 !== 11) ? 'sat' : (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) ? 'sata' : 'sati'; };

  /* Kalkulator: komada nedeljno × minuta × nedelja godišnje */
  function initCalc() {
    const c = $('[data-calc]');
    if (!c || c._on) return;
    c._on = true;
    const range = $('[data-calc-range]', c), n = $('[data-calc-n]', c), h = $('[data-calc-hours]', c), unit = $('[data-calc-unit]', c);
    const minutes = parseInt(c.dataset.min, 10) || 8, weeks = parseInt(c.dataset.weeks, 10) || 50, max = parseInt(range.max, 10) || 10, lo = parseInt(range.min, 10) || 1;
    const paint = () => {
      const v = parseInt(range.value, 10) || 0;
      const hours = Math.round(v * minutes * weeks / 60);
      if (n) n.textContent = v;
      if (h) h.textContent = hours;
      if (unit) unit.textContent = hoursWord(hours);
      range.style.setProperty('--lznp-fill', ((v - lo) / Math.max(1, max - lo) * 100) + '%');
      const box = h && h.closest('.lznp-calc__v'); if (box) { box.classList.remove('is-tick'); void box.offsetWidth; box.classList.add('is-tick'); setTimeout(() => box.classList.remove('is-tick'), 220); }
    };
    range.addEventListener('input', paint);
    range.addEventListener('change', () => track('lznp_calc', { pieces: range.value }));
    paint();
  }

  /* Konfete u bonusu */
  const confetti = (cv) => {
    if (!cv || reduce) return;
    const r = cv.getBoundingClientRect();
    const W = cv.width = Math.max(1, Math.round(r.width)), H = cv.height = Math.max(1, Math.round(r.height));
    const ctx = cv.getContext('2d');
    const cols = ['#B10F1A', '#E8363C', '#FFFFFF', '#FFD34D'];
    const ps = Array.from({ length: 110 }, () => ({ x: W / 2 + (Math.random() - .5) * 80, y: H * .3, vx: (Math.random() - .5) * 12, vy: -Math.random() * 11 - 3, s: 4 + Math.random() * 5, r: Math.random() * 6, vr: (Math.random() - .5) * .4, c: cols[Math.floor(Math.random() * cols.length)] }));
    const t0 = performance.now();
    const step = (t) => {
      ctx.clearRect(0, 0, W, H);
      ps.forEach((p) => { p.vy += .3; p.x += p.vx; p.y += p.vy; p.r += p.vr; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * .6); ctx.restore(); });
      if (t - t0 < 2200) requestAnimationFrame(step); else ctx.clearRect(0, 0, W, H);
    };
    requestAnimationFrame(step);
  };

  /* Kartice: okreni, broji, posle svih bonus */
  function initCards() {
    const g = $('[data-lznp-game]');
    if (!g || g._on) return;
    g._on = true;
    const cards = $$('[data-card]', g);
    const total = cards.length;
    const found = $('[data-found]', g), fill = $('[data-found-fill]', g), bonus = $('[data-bonus]', g);
    const paint = (restore) => {
      cards.forEach((c) => { const on = st.open.includes(c.dataset.card); c.classList.toggle('is-open', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      const n = st.open.length;
      if (found) { found.textContent = n >= total && total ? (g.dataset.foundAll || '') : tpl(g.dataset.foundTpl, { n, total }); found.classList.toggle('is-all', n >= total && total > 0); }
      if (fill) fill.style.width = (total ? n / total * 100 : 0) + '%';
      if (bonus) {
        const was = !bonus.hidden;
        bonus.hidden = !(total && n >= total);
        if (!bonus.hidden && !was && !restore) { setTimeout(() => confetti($('[data-confetti]', bonus)), 80); setTimeout(() => bonus.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }), 350); track('lznp_bonus', {}); }
      }
    };
    cards.forEach((c) => c.addEventListener('click', () => {
      const id = c.dataset.card;
      if (st.open.includes(id)) { st.open = st.open.filter((x) => x !== id); } else { st.open.push(id); track('lznp_card', { card: id }); }
      save(); paint();
    }));
    paint(true);
  }

  /* Komadi: čipovi kategorija, prvih „limit“, „Prikaži još“ */
  function initProducts() {
    const p = $('[data-lznp-prod]');
    if (!p || p._on) return;
    p._on = true;
    const limit = parseInt(p.dataset.limit, 10) || 6;
    const tabs = $$('[data-tab]', p), pools = $$('[data-pool]', p);
    /* Veličina se bira na strani i ne pamti se: kupac bira sam pri svakom ulasku. */
    let size = '';
    const fits = (it) => !size || it.dataset.stype === 'bottom' || (it.dataset.sizes || '').includes('|' + size + '|');
    let paintSize = null;
    const render = () => {
      if (paintSize) paintSize();
      tabs.forEach((t) => {
        const on = parseInt(t.dataset.tab, 10) === st.tab;
        t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
        const pool = pools.find((x) => x.dataset.pool === t.dataset.tab);
        const n = $('[data-tab-n]', t); if (n && pool) n.textContent = $$('[data-item]', pool).filter(fits).length;
      });
      pools.forEach((pool) => {
        const on = parseInt(pool.dataset.pool, 10) === st.tab;
        pool.hidden = !on;
        if (!on) return;
        const all = $$('[data-item]', pool);
        /* Izbor veličine: gornji delovi se filtriraju po izabranoj veličini, pantalone (širina) ostaju vidljive */
        const items = all.filter(fits);
        all.forEach((it) => { if (!items.includes(it)) it.hidden = true; });
        const expanded = pool.dataset.expanded === '1';
        items.forEach((it, i) => { it.hidden = !(expanded || i < limit); if (!it.hidden) it.style.animationDelay = Math.min(i, 8) * 40 + 'ms'; });
        const more = $('[data-more]', pool);
        if (more) { more.hidden = expanded || items.length <= limit; more.textContent = tpl(p.dataset.moreTpl, { n: items.length - limit }); }
      });
    };
    /* „Koju veličinu nosiš?“ + „Ne znaš veličinu?“ (visina i težina → veličina, lz-size-reco.js) */
    const box = $('[data-size-pick]', p);
    if (box) {
      const chips = $$('[data-size-chip]', box), hint = $('[data-size-hint-out]', box);
      const tops = () => $$('[data-item][data-stype="top"]', p);
      const countFor = (sz) => tops().filter((it) => (it.dataset.sizes || '').includes('|' + sz + '|')).length;
      paintSize = () => {
        chips.forEach((c) => {
          const sz = c.dataset.sizeChip, n = countFor(sz);
          c.classList.toggle('is-on', sz === size);
          c.disabled = n === 0 && sz !== size;
          const small = $('[data-size-n]', c); if (small) small.textContent = n ? n : (p.dataset.sizeNone || '');
        });
        if (hint) hint.textContent = size ? tpl(p.dataset.sizeHintOn, { size, n: countFor(size), gone: tops().length - countFor(size) }) : (p.dataset.sizeHint || '');
      };
      chips.forEach((c) => c.addEventListener('click', () => { size = size === c.dataset.sizeChip ? '' : c.dataset.sizeChip; render(); track('lznp_size', { size }); }));
      const calc = $('[data-np-calc]', box);
      if (calc) {
        const out = $('[data-np-calc-out]', calc);
        $('[data-np-calc-form]', calc).addEventListener('submit', (e) => {
          e.preventDefault();
          const h = $('[data-np-calc-h]', calc).value, w = $('[data-np-calc-w]', calc).value;
          const r = window.lzSizeReco ? window.lzSizeReco(h, w) : null;
          out.hidden = false;
          if (!r || !r.shirt) { out.textContent = calc.dataset.none || ''; return; }
          out.innerHTML = tpl(calc.dataset.result || '{size}', { size: '<b>' + r.shirt + '</b>' });
          const chip = chips.find((c) => c.dataset.sizeChip === r.shirt);
          if (chip && size !== r.shirt) { size = r.shirt; render(); }
          track('lznp_calc_size', { h, w, size: r.shirt });
        });
      }
    }
    tabs.forEach((t) => t.addEventListener('click', () => { st.tab = parseInt(t.dataset.tab, 10) || 0; save(); render(); track('lznp_tab', { tab: t.textContent.trim() }); }));
    $$('[data-more]', p).forEach((b) => b.addEventListener('click', () => { const pool = b.closest('[data-pool]'); if (pool) { pool.dataset.expanded = '1'; render(); } }));
    if (!pools.some((x) => parseInt(x.dataset.pool, 10) === st.tab)) st.tab = 0;
    render();
  }

  const init = () => { initCalc(); initCards(); initProducts(); };
  window.__lznp = init;
  init();
  document.addEventListener('shopify:section:load', init);
})();
